import React from 'react';

import './scss/NewEpisode.scss';

const NewEpisode = (props = {}) => {
	const isPremium = props.isPremium,
		label = props.label || '',
		meta = props.meta || {};

	return (<div className={`new-episode${meta.position === 'top-left' ? ' plm-left' : ' plm-right'}`}>{isPremium ? `premium${label ? ' | ' : ''}` : ''}{label}</div>);
}

export default NewEpisode;